import { z } from 'zod';
import { i18next } from '../adapters/i18next';
import { getShortCode } from '../config/languages';

// 永続化済みの auth ストア（zustand persist, key: 'auth'）から表示言語を読むためのスキーマ
const persistedLocaleSchema = z.object({
  state: z.object({
    locale: z.string()
  })
});

/** LocalStorage に保存されたクライアント表示言語（auth ストア）を読む。 */
function readStoredLanguage(): string | undefined {
  try {
    const raw = globalThis.localStorage?.getItem('auth');
    if (!raw) return undefined;
    const parsed = persistedLocaleSchema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data.state.locale : undefined;
  } catch {
    return undefined;
  }
}

/**
 * 現在の表示言語の短縮コード（ja / en / zhCN 等）を返す。
 * 解決順: i18next.language → LocalStorage 保存言語 → en。
 */
export function getCurrentShortLocale(): string {
  const language = i18next.language || readStoredLanguage();
  return language ? getShortCode(language) : 'en';
}